var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: { id: "app" },
      on: { mousemove: _vm.moveEvent, click: _vm.moveEvent }
    },
    [
      _c("router-view", { staticClass: "router-view" }),
      _vm._v(" "),
      _vm.showPreviewImg
        ? _c("vue-picture-viewer", {
            attrs: {
              imgData: _vm.previewImgs,
              "select-index": _vm.previewIndex
            },
            on: {
              "close-viewer": function($event) {
                _vm.showPreviewImg = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }